import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Machine} from "../../../model/machine";
import {MachinesService} from "../../../services/machines.service";

@Component({
  selector: 'app-map-cluster-details',
  templateUrl: './map-cluster-details.component.html',
  styleUrls: ['./map-cluster-details.component.scss']
})
export class MapClusterDetailsComponent {

  @Output() public onMachineSelected: EventEmitter<string> = new EventEmitter<string>();

  public aliasFilter: string = "";

  private machineList: Machine[];


  constructor(public machinesService: MachinesService) {
  }

  @Input()
  set machineUuids(machineUuids: string[]) {
    this.machineList = [];
    const promises: any[] = [];
    machineUuids.forEach(machineUuid => {
      const promise = this.machinesService.getMachine(machineUuid).toPromise()
        .then(response => {
          this.machineList.push(response.machine);
        });
      promises.push(promise);
    });
    Promise.all(promises).then((): void => {
      this.machineList.sort((a, b) => {
        if (a.alias < b.alias) {
          return -1;
        }
        return (a.alias > b.alias) ? 1 : 0;
      });
    });
  }

  get filteredMachines(): Machine[] {
    if (this.machineList) {
      return this.machineList.filter(machine => machine.alias?.toUpperCase().includes(this.aliasFilter.toUpperCase()));
    }
    return this.machineList;
  }

}
